module.exports = __webpack_public_path__ + "img/stock4.c2b675fd.png";